export default __webpack_public_path__ + "static/media/Birmingham.be41d66c.jpg";